module.exports = require("/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 422
// module chunks = 231608221292675